import { X } from "lucide-react";
import { isKariBday } from "../utils/dateUtils";

const WelcomeModal = ({ onClose }) => {
  const celebratory = isKariBday();

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 font-quicksand">
      <div
        className="bg-white p-6 max-w-md mx-4 relative"
        style={{
          borderRadius: "20px",
          border: "2px solid #f9a8d4",
          boxShadow: "0 8px 32px rgba(176,106,179,0.15)",
        }}
      >
        <button
          onClick={onClose}
          className="absolute top-3 right-3 hover:scale-110 transition-transform"
          style={{ color: "#c4b5fd" }}
        >
          <X size={20} />
        </button>

        <div className="text-center mb-5">
          <h3 className="text-lg font-bold mb-4" style={{ color: "#b06ab3" }}>
            Con cariño para Karime 🩵
          </h3>

          <p style={{ color: "#6b7280" }} className="text-sm leading-relaxed">
            Esta app fue hecha con mucho amor por una perrísima como homenaje a
            Karime Pindter. No es oficial ni está afiliada con ella o su equipo,
            pero sí está llena de admiración.
          </p>

          <p
            className="italic mt-4 text-sm font-semibold"
            style={{ color: "#b06ab3" }}
          >
            Solo vibes y frases icónicas 💅✨
          </p>
        </div>

        {celebratory && (
          <div
            className="mb-5 font-semibold text-sm flex flex-col items-center italic text-center"
            style={{ color: "#f472b6" }}
          >
            <span>🎂 ¡Feliz cumpleaños, Kari!</span>
            <span>Gracias por tantas frases que nos dan vida 💖</span>
          </div>
        )}

        <div className="flex justify-center">
          <button
            onClick={onClose}
            className="px-5 py-2 bg-custom-blue text-white rounded-full active:scale-95 transition-transform"
            style={{ boxShadow: "0 4px 12px rgba(125,211,252,0.4)" }}
          >
            Cerrar
          </button>
        </div>
      </div>
    </div>
  );
};

export default WelcomeModal;
